import React from "react";
import { Button } from "semantic-ui-react";
import Shutdown1_PSM1 from "./Shutdown1_PSM1";
import Shutdown2_PSM1 from "./Shutdown2_PSM1";
import Shutdown3_PSM1 from "./Shutdown3_PSM1";
import Shutdown4_PSM1 from "./Shutdown4_PSM1";
// import Shutdown4 from "./Shutdown4";
// import Shutdown5 from "./Shutdown5";

const Shutdown_PSM1 = () => {
  const [toggleButton, setToggleButton] = React.useState("1");

  const handleClick = (e, { id }) => {
    setToggleButton(id);
  };

  const renderSwitch = (param) => {
    switch (param) {
      case "1":
        return <Shutdown1_PSM1 />;
      case "2":
        return <Shutdown2_PSM1 />;
      case "3":
        return <Shutdown3_PSM1 />;
      case "4":
        return <Shutdown4_PSM1 />;
      // case '5':
      //     return <Shutdown5/>;
      default:
        return <Shutdown1_PSM1 />;
    }
  };

  return (
    <div style={styles.div}>
      {/* <h2 style={{textAlign : 'left'}}>test1</h2> */}
      <Button.Group toggle style={styles.toggle}>
        <Button
          size="medium"
          id="1"
          active={toggleButton === "1"}
          onClick={handleClick}
          content="SHUTDOWNS PAGE1"
        />
        <Button
          size="medium"
          id="2"
          active={toggleButton === "2"}
          onClick={handleClick}
          content="SHUTDOWNS PAGE2"
        />
        <Button
          size="medium"
          id="3"
          active={toggleButton === "3"}
          onClick={handleClick}
          content="SHUTDOWNS PAGE3"
        />
        <Button
          size="medium"
          id="4"
          active={toggleButton === "4"}
          onClick={handleClick}
          content="SHUTDOWNS PAGE4"
        />
        {/* <Button
                    size='medium'
                    id='5'
                    active={toggleButton==='5'}
                    onClick={handleClick}
                    content='SHUTDOWNS PAGE5'
                /> */}
      </Button.Group>
      {renderSwitch(toggleButton)}
    </div>
  );
};

const styles = {
  div: {
    textAlign: "center",
  },
  toggle: {
    marginLeft: "8px",
  },
};

export default Shutdown_PSM1;
